module.exports = __webpack_public_path__ + "img/export3.jpg";